module.exports = "<captain-app-version-page></captain-app-version-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/captainAppVersionView.html
// module id = 2185
// module chunks = 0